export const p2PhaseStudyList = [
    {
        key: 0,
        display: 'Phase I',
    },
    {
        key: 1,
        display: 'Phase II',
    },
    {
        key: 2,
        display: 'Phase III',
    },
    {
        key: 3,
        display: 'Phase IV'
    },
    {
        key: 4,
        display: 'New indication drug trial'
    },
    {
        key: 5,
        display: 'N/A'
    },
];

export const typeOfReview = [
    { key: 0, display: 'Full Review' },
    { key: 1, display: 'Phase 1 Review' },
    { key: 2, display: 'Expedited Review' },
];

export const declareStudentKey = 'declareStudent';
export const declareInvKey = 'declareInv';
export const HAEndorsementKey = 'H';
export const universitiesEndorsementKey = 'U';
export const HAUniversitiesEndorsementKey = 'C';

export const commentStatusEnum = {
    DRAFT: 'Draft',
    RESOLVED: 'Resolved',
    PENDING: 'Pending',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    UNHANDLED: 'Unhandled',
};